module.exports = __webpack_public_path__ + "img/icon-date.24f11a12.svg";